import type * as Microcredits from '@src/@types/microcredits';

export const PERSISTENT_OFFER_KEY = '__persistent-offers__';

export const getSessionOffers = (): Microcredits.List.IMicrocredit[] => {
  const raw = sessionStorage.getItem(PERSISTENT_OFFER_KEY);
  return raw ? JSON.parse(raw) : [];
};

export const setSessionOffers = (offers: Microcredits.List.IMicrocredit[]) => {
  sessionStorage.setItem(PERSISTENT_OFFER_KEY, JSON.stringify(offers));
};
